<script lang="ts" context="module">
  import { makeSlug } from "@utils/string";

  export interface EventFilter {
    name: string;
    filter: (content: EventEntry[]) => EventEntry[];
  }
</script>

<script lang="ts">
  import { inView } from "../../svelte/actions/inView";
  import { onMount } from "svelte";
  import EventSlider from "../events/EventSlider.svelte";
  import type { EventEntry } from "../../types/entries";
  export let content: EventEntry[];
  const eventFilters: EventFilter[] = [
    {
      name: "For Men",
      filter: (events): EventEntry[] =>
        events.filter((event) =>
          event.topics.some((topic) => topic.title === "For Men"),
        ),
    },
    {
      name: "For Women",
      filter: (events): EventEntry[] =>
        events.filter((event) =>
          event.topics.some((topic) => topic.title === "For Women"),
        ),
    },
    {
      name: "Retreats",
      filter: (events): EventEntry[] =>
        events.filter((event) => {
          // TODO: Remove this when we're no longer using blueprints to indicate event type
          if (!!event.event_type?.title) {
            return event.event_type?.title === "Multi-day Retreat";
          }
          return event.blueprint.title === "Multi-day Retreat";
        }),
    },
    {
      name: "Video Study Groups",
      filter: (events): EventEntry[] =>
        events.filter((event) => {
          // TODO: Remove this when we're no longer using blueprints to indicate event type
          if (!!event.event_type?.title) {
            return event.event_type?.title === "Video Study";
          }
          return event.blueprint.title === "Video Study";
        }),
    },
  ];

  let hash = "";

  onMount(() => {
    hash = window.location.hash;
  });

  function updateActiveFilter(filterName: string) {
    hash = makeSlug(filterName);
  }

  $: activeFilter = hash.replace("#", "");
</script>

<section class="z-10 transform-gpu">
  <div class="w-screen md:w-auto overflow-y-auto top-0 sticky z-10 bg-black/80">
    <div class="flex py-4 md:justify-center">
      {#each eventFilters as filter}
        <a
          href={`#${makeSlug(filter.name)}`}
          class={`shrink-0  text-h3 font-bold px-4 pb-2  ${activeFilter === makeSlug(filter.name) ? "text-white opacity-100 border-b-2 border-white" : "text-white opacity-60 border-b border-n400 "}`}
          on:click={() => updateActiveFilter(filter.name)}>{filter.name}</a
        >
      {/each}
    </div>
  </div>
  {#each eventFilters as filter, index}
    <section
      use:inView={{ top: 200, bottom: 500 }}
      on:enter={() => updateActiveFilter(filter.name)}
      id={makeSlug(filter.name)}
      class="pt-12"
    >
      <EventSlider
        title={filter.name}
        events={filter.filter(content).sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateB.getTime() - dateA.getTime();
        })}
      />
    </section>
  {/each}
</section>
